import {
  API_ENDPOINT,
  useClientApiV1GamesResultsCreateMutation,
} from '../../resources/@types/accountSchema';

interface UseClientV1GamesResultsMutation {
  options?: Parameters<typeof useClientApiV1GamesResultsCreateMutation>[0]['options'];
}

export function useGamesResultsCreateMutation({ options }: UseClientV1GamesResultsMutation) {
  return useClientApiV1GamesResultsCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_GAMES_RESULTS,
    options,
  });
}
